module.exports = __webpack_public_path__ + "static/media/IconSubjectsData.530c4165.svg";